/**
 * Created by vaibhav on 1/4/18
 */
import React from 'react'
import PropTypes from 'prop-types'

const PartnerOfferings = ({ gridItems }) => (
    <div className="columns">
        {gridItems.map(item => (
            <div key={item.image} className="column is-4" style={{borderRadius: '2px'}}>
                <section className="section">
                    <p className="has-text-centered">
                        <img className="how-it-works-svg" alt="" src={item.image} />
                    </p>
                    <h3>{item.subheader}</h3>
                    <p>{item.text}</p>
                </section>
            </div>
        ))}
    </div>
);

PartnerOfferings.propTypes = {
    gridItems: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            subheader: PropTypes.string,
            text: PropTypes.string,
        })
    ),
};

export default PartnerOfferings;



// WEBPACK FOOTER //
// ./src/components/PartnerOfferings/index.js